import React from 'react';

function About({ language, t }) {
  const isArabic = language === 'ar';

  return (
    <main className="about" dir={isArabic ? 'rtl' : 'ltr'}>
      <section className="page-header">
        <h1>{t.aboutUs}</h1>
      </section>

      <section className="about-content">
        <div className="about-section">
          <h2>{t.whoWeAre}</h2>
          <p>{t.whoWeAreText}</p>
        </div>

        <div className="about-section">
          <h2>{t.ourMission}</h2>
          <p>{t.ourMissionText}</p>
        </div>

        <div className="about-section">
          <h2>{t.ourVision}</h2>
          <p>{t.ourVisionText}</p>
        </div>

        <div className="about-section">
          <h2>{t.ourPhilosophy}</h2>
          <p>{t.ourPhilosophyText}</p>
        </div>
      </section>
    </main>
  );
}

export default About;
